import React from 'react'
import { Routes, Route } from 'react-router-dom'
import LandingPage from './LandingPage'

const DiasensRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
    </Routes>
  )
}

export default DiasensRoutes
